export default __webpack_public_path__ + "static/media/note.3772c718.svg";